import React from "react";
import { Card, Typography, Empty } from "antd";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from "recharts";
import { formatCurrency } from "../../../services/utils";

const { Title } = Typography;
const COLORS = ["#00C49F", "#FFBB28", "#FF8042"];

interface CollectionsStatusProps {
  received: number;
  to_receive: number;
  overdue: number;
}

export default function CollectionsStatus({ received, to_receive, overdue }: CollectionsStatusProps) {
  const data = [
    { name: "Recebidas", value: received },
    { name: "A Receber", value: to_receive },
    { name: "Em Atraso", value: overdue },
  ].filter((d) => d.value > 0);

  return (
    <Card title={<Title level={5}>Status das Cobranças</Title>} bordered={false} style={{ height: "100%" }}>
      {data.length > 0 ? (
        <div style={{ width: "100%", height: 250 }}>
          <ResponsiveContainer>
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={80}
                paddingAngle={5}
                dataKey="value"
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip formatter={(value: any) => formatCurrency(Number(value) || 0)} />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <Empty description="Sem dados" />
      )}
    </Card>
  );
}
